<template>
    <div class="page-setting has-bc biz-new-bill-comp">
        <import-meter-record loginType="COMPANY" type="ELECTRICITY" :open="modalState.electricity" @closeModal="modalState.electricity = false" v-model="insertData.electricityBill" @billChargeMode="billChargeMode.electricity=$event" @meterCid="setMeterCid($event, 'ELECTRICITY')"></import-meter-record>
        <import-meter-record loginType="COMPANY" type="WATER" :open="modalState.water" @closeModal="modalState.water = false" v-model="insertData.waterBill" @billChargeMode="billChargeMode.water=$event" @meterCid="setMeterCid($event, 'WATER')"></import-meter-record>
        <import-meter-record loginType="COMPANY" type="GAS" :open="modalState.gas" @closeModal="modalState.gas = false" v-model="insertData.gasBill" @billChargeMode="billChargeMode.gas=$event" @meterCid="setMeterCid($event, 'GAS')"></import-meter-record>
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button v-if="isEdit" class="default-button publish" @click="updateData" :disabled="status.isDisable">儲存</button>
                    <button v-else class="default-button publish" @click="saveData" :disabled="status.isDisable">新增</button>
                </div>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                選擇收費方式
                <bill-recive-tips-hover/>
            </div>
            <div v-if="insertData.hasPaid" class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            收費方式
                        </div>
                        <div class="biz-table-content">
                            <span v-if="insertData.billType === 'PERIOD'">
                                系統預設計費期間
                            </span>
                            <span v-else-if="insertData.billType === 'DAY'">
                                自訂收費日
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="toogle-body row-block" slot="toogle-body">
                <border-radio v-model="insertData.billType" val="PERIOD" text="系統預設計費期間"></border-radio>
                <border-radio v-model="insertData.billType" val="DAY" text="自訂收費日"></border-radio>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                帳單明細
            </div>
            <div v-if="insertData.hasPaid && insertData.billType === 'PERIOD'" class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            系統預設計費期間
                        </div>
                        <div class="biz-table-content">
                            {{insertData.periodStartDate}}~{{insertData.periodEndDate}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            帳單名稱
                        </div>
                        <div class="biz-table-content">
                            {{insertData.billName}}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="insertData.billType === 'PERIOD'" class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 系統預設計費期間
                        </div>
                        <span v-show="error.billPeriodSeq" class="error-with-title">{{error.billPeriodSeq}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select refName="period" class="select-scroll biz-h180" :class="{error: error.billPeriodSeq}" :selectMsg="seletcMsg.period" @getId="getSelectId" :isEdit="seletcMsg.period!=='選擇系統預設計費期間'" border="1px solid #d5dad8" bgColor="#fff" :setDefault="status.sDefault">
                            <ul>
                                <li :data-id="period.billPeriodSeq"  v-for="(period,index) in periodsList" :key="index">
                                    <div class="is-created" v-if="period.created">{{getFormatDateTime(period.periodStartDate)}}~{{getFormatDateTime(period.periodEndDate)}}  ( 已建立 )</div>
                                    {{!period.created?getFormatDateTime(period.periodStartDate)+'~'+getFormatDateTime(period.periodEndDate):''}}
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 帳單名稱
                        </div>
                        <span v-show="error.billName" class="error-with-title">{{error.billName}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.billName}" type="text" v-model="insertData.billName" placeholder="請填寫帳單名稱">
                    </div>
                </div>
            </div>
            <div v-if="insertData.hasPaid && insertData.billType === 'DAY'" class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            自訂收費日
                        </div>
                        <div class="biz-table-content">
                            {{insertData.billDueTime}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            自訂計費期間
                        </div>
                        <div class="biz-table-content">
                            <span v-if="insertData.periodStartDate">
                                {{insertData.periodStartDate}}~{{insertData.periodEndDate}}
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            帳單名稱
                        </div>
                        <div class="biz-table-content">
                            {{insertData.billName}}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="insertData.billType === 'DAY'" class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 自訂收費日
                        </div>
                        <span v-show="error.billDueTime" class="error-with-title">{{error.billDueTime}}</span>
                    </label>
                    <div class="input-arear">
                        <date-picker v-model="insertData.billDueTime"  :class="{'active': insertData.billDueTime, 'error': error.billDueTime}" placeholder="請選擇自訂收費日" format="YYYY-MM-DD" valueType="format"></date-picker>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 自訂計費期間
                        </div>
                        <span v-show="error.periodDate" class="error-with-title">{{error.periodDate}}</span>
                    </label>
                    <div class="input-arear">
                        <date-picker v-model="periodDate" :class="{'active': periodDate.length, 'error': error.periodDate}" placeholder="請選擇自訂計費期間" format="YYYY-MM-DD" range valueType="format"></date-picker>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 帳單名稱
                        </div>
                        <span v-show="error.billName" class="error-with-title">{{error.billName}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.billName}" type="text" v-model="insertData.billName" placeholder="請填寫帳單名稱">
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                帳單金額
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 租金
                            </div>
                            <span v-show="error.rent" class="error-with-title">{{error.rent}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.rent}" type="number" @keyup="setPriceForLandlord('rent')" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.rent" placeholder="例如： 6000 " >
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.rentForLandlord" :val="true"  :isPropChecked="inLandlordReport.rentForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.rentForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.rentForLandlord" class="error-with-title">{{error.rentForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.rentForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.rentForLandlord" placeholder="例如： 6000 ">
                            <div class="note">{{(serviceFeeRate*100).toFixed(2)}}%服務費</div>
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 訂金
                            </div>
                            <span v-show="error.bookingDeposit" class="error-with-title">{{error.bookingDeposit}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.bookingDeposit}" type="number" @keyup="setPriceForLandlord('bookingDeposit')" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.bookingDeposit" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.bookingDepositForLandlord" :val="true"  :isPropChecked="inLandlordReport.bookingDepositForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.bookingDepositForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.bookingDepositForLandlord" class="error-with-title">{{error.bookingDepositForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.bookingDepositForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.bookingDepositForLandlord" placeholder="例如： 6000 ">
                            <div class="note">{{(serviceFeeRate*100).toFixed(2)}}%服務費</div>
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 押金
                            </div>
                            <span v-show="error.contractDeposit" class="error-with-title">{{error.contractDeposit}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.contractDeposit}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.contractDeposit" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.contractDepositForLandlord" :val="true"  :isPropChecked="inLandlordReport.contractDepositForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.contractDepositForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.contractDepositForLandlord" class="error-with-title">{{error.contractDepositForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.contractDepositForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.contractDepositForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 水費
                            </div>
                            <span v-show="error.waterBill" class="error-with-title">{{error.waterBill}}</span>
                        </label>
                        <div class="input-arear">
                            <div class="meter-group h-align">
                                <input :disabled="insertData.hasPaid" :class="{error: error.waterBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.waterBill" placeholder="例如： 6000 ">
                                <button class="border-button-gray" @click="importMeter('WATER')">房客拍表紀錄</button>
                            </div>
                            <div v-if="billChargeMode.water"  class="meter-warning h-align">
                                <img src="@/assets/img/icon/info_pink.svg" alt="">
                                合約設定為{{billChargeMode.water}}
                            </div>
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.waterBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.waterBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.waterBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.waterBillForLandlord" class="error-with-title">{{error.waterBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.waterBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.waterBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 電費
                            </div>
                            <span v-show="error.electricityBill" class="error-with-title">{{error.electricityBill}}</span>
                        </label>
                        <div class="input-arear">
                            <div class="meter-group h-align">
                                <input :disabled="insertData.hasPaid" :class="{error: error.electricityBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.electricityBill" placeholder="例如： 6000 ">
                                <button class="border-button-gray" @click="importMeter('ELECTRICITY')">房客拍表紀錄</button>
                            </div>
                            <div v-if="billChargeMode.electricity" class="meter-warning h-align">
                                <img src="@/assets/img/icon/info_pink.svg" alt="">
                                合約設定為{{billChargeMode.electricity}}
                            </div>
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.electricityBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.electricityBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.electricityBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.electricityBillForLandlord" class="error-with-title">{{error.electricityBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.electricityBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.electricityBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 瓦斯費
                            </div>
                            <span v-show="error.gasBill" class="error-with-title">{{error.gasBill}}</span>
                        </label>
                        <div class="input-arear">
                            <div class="meter-group h-align">
                                <input :disabled="insertData.hasPaid" :class="{error: error.gasBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.gasBill" placeholder="例如： 6000 ">
                                <button class="border-button-gray" @click="importMeter('GAS')">房客拍表紀錄</button>
                            </div>
                            <div v-if="billChargeMode.gas" class="meter-warning h-align">
                                <img src="@/assets/img/icon/info_pink.svg" alt="">
                                合約設定為{{billChargeMode.gas}}
                            </div>
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.gasBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.gasBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.gasBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.gasBillForLandlord" class="error-with-title">{{error.gasBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.gasBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.gasBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 網路費
                            </div>
                            <span v-show="error.internetBill" class="error-with-title">{{error.internetBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.internetBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.internetBill" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.internetBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.internetBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.internetBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.internetBillForLandlord" class="error-with-title">{{error.internetBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.internetBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.internetBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 有線電視
                            </div>
                            <span v-show="error.tvBill" class="error-with-title">{{error.tvBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.tvBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.tvBill" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.tvBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.tvBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.tvBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.tvBillForLandlord" class="error-with-title">{{error.tvBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.tvBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.tvBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 修繕工程
                            </div>
                            <span v-show="error.repairBill" class="error-with-title">{{error.repairBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.repairBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.repairBill" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.repairBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.repairBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.repairBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.repairBillForLandlord" class="error-with-title">{{error.repairBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.repairBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.repairBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 清潔費
                            </div>
                            <span v-show="error.cleaningBill" class="error-with-title">{{error.cleaningBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.cleaningBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.cleaningBill" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.cleaningBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.cleaningBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.cleaningBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.cleaningBillForLandlord" class="error-with-title">{{error.cleaningBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.cleaningBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.cleaningBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 停車費
                            </div>
                            <span v-show="error.parkingBill" class="error-with-title">{{error.parkingBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.parkingBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.parkingBill" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.parkingBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.parkingBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.parkingBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.parkingBillForLandlord" class="error-with-title">{{error.parkingBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.parkingBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.parkingBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 管理費
                            </div>
                            <span v-show="error.managementBill" class="error-with-title">{{error.managementBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.managementBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.managementBill" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.managementBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.managementBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.managementBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.managementBillForLandlord" class="error-with-title">{{error.managementBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.managementBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.managementBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 其他
                            </div>
                            <span v-show="error.otherBill" class="error-with-title">{{error.otherBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :disabled="insertData.hasPaid" :class="{error: error.otherBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.otherBill" placeholder="例如： 6000 ">
                            <checkbox v-if="status.isLandlord" msg="加入屋主對帳單" v-model="inLandlordReport.otherBillForLandlord" :val="true"  :isPropChecked="inLandlordReport.otherBillForLandlord"></checkbox>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inLandlordReport.otherBillForLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 加入屋主對帳單金額
                            </div>
                            <span v-show="error.otherBillForLandlord" class="error-with-title">{{error.otherBillForLandlord}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.otherBillForLandlord}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.otherBillForLandlord" placeholder="例如： 6000 ">
                        </div>
                    </div>
                </div>
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> 實繳金額
                            </div>
                            <span v-show="error.otherBill" class="error-with-title">{{error.otherBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.otherBill}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.actualPayAmount">
                        </div>
                    </div> 
                </div>
                <div class="row-block">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 狀態
                        </div>
                        <span v-show="error.otherBill" class="error-with-title">{{error.otherBill}}</span>
                    </label>
                    <div class="input-arear">
                        <select :class="{error: error.otherBill}" v-model.number="insertData.billStatus">
                            <option value="">請選擇狀態</option>
                            <option :value="1">待繳款</option>
                            <option :value="2">已繳款</option>
                            <option :value="3">過期未繳</option>
                            <option :value="4">收到部分款項</option>
                            <option :value="5">逾期繳款</option>
                        </select>
                    </div>
                </div>
            </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import borderRadio from '@/components/bussiness/widges/input/borderRadio.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import importMeterRecord from '@/components/bussiness/widges/modals/importMeterRecord.vue';
import DatePicker from 'vue2-datepicker';
import billReciveTipsHover from '@/components/bussiness/widges/tips/billReciveTipsHover.vue';
import { 
    createBill,
    getBillPeriods,
    updateBill,
    getEditBill,
    getHouseLandlord
} from "@/apis/company/bill.js"; 
import { 
    getServiceFeeRate
} from "@/apis/company/leaseMgt.js";
import { mapGetters } from 'vuex'
const defaultParams = {
    "contractCid": null,
    "billName": null,
    "billPeriodSeq": null,
    "billDueTime": null,
    "periodStartDate": null,
    "periodEndDate": null,
    "billType": null,
    "rent": null,
    "bookingDeposit": null,
    "contractDeposit": null,
    "repairBill": null,
    "waterBill": null,
    "electricityBill": null,
    "parkingBill": null,
    "managementBill": null,
    "internetBill": null,
    "tvBill": null,
    "cleaningBill": null,
    "gasBill": null,
    "otherBill": null,
    "rentForLandlord": null,
    "bookingDepositForLandlord": null,
    "contractDepositForLandlord": null,
    "repairBillForLandlord": null,
    "waterBillForLandlord": null,
    "electricityBillForLandlord": null,
    "gasBillForLandlord": null,
    "parkingBillForLandlord": null,
    "managementBillForLandlord": null,
    "internetBillForLandlord": null,
    "tvBillForLandlord": null,
    "cleaningBillForLandlord": null,
    "otherBillForLandlord": null,
    "billStatus": null,
    "utilityIdList": []
}
export default {
    data () {
        return {
            insertData: JSON.parse(JSON.stringify(defaultParams)),
            inLandlordReport: {
                rentForLandlord: true,
                bookingDepositForLandlord: false,
                contractDepositForLandlord: false,
                repairBillForLandlord: false,
                waterBillForLandlord: false,
                electricityBillForLandlord: false,
                gasBillForLandlord: false,
                parkingBillForLandlord: false,
                managementBillForLandlord: false,
                internetBillForLandlord: false,
                tvBillForLandlord: false,
                cleaningBillForLandlord: false,
                otherBillForLandlord: false,
            },
            error: JSON.parse(JSON.stringify(defaultParams)),
            periodsList: [],
            periodDate: [],
            serviceFeeRate: 0,
            tipStatus: {
                payway: false,
            },
            status:{
                isDisable: false,
                isDefault: false,
                isLandlord: false
            },
            seletcMsg: {
                house: '請選擇房源',
                period: '選擇系統預設計費期間'
            },
            billChargeMode: {
                electricity: null,
                water: null,
                gas: null
            },
            modalState: {
                electricity: false,
                water: false,
                gas: false
            }
        }
    },
    props: {
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    created () {
        this.getServiceFeeRate(this.$route.query.contractSeq)
        if(this.isEdit){
            this.getEditBill()
        }else{
            this.getBillPeriods(this.$route.query.contractId)
            this.getHouseLandlord(this.$route.query.contractId)
            this.insertData.contractCid = this.$route.query.contractId
            this.insertData.billType = 'PERIOD'
        }
    },
    mounted () {
    },
    watch: {
        insertData: {
            handler: function (val) {
                if(this.isEdit){
                   
                    if(val.rentForLandlord){
                        this.inLandlordReport.rentForLandlord = true
                    }else{
                        this.inLandlordReport.rentForLandlord = false
                    }
                    if(val.bookingDepositForLandlord){
                        this.inLandlordReport.bookingDepositForLandlord = true
                    }else{
                        this.inLandlordReport.bookingDepositForLandlord = false
                    }
                    if(val.contractDepositForLandlord){
                        this.inLandlordReport.contractDepositForLandlord = true
                    }
                    if(val.waterBillForLandlord){
                        this.inLandlordReport.waterBillForLandlord = true
                    }
                    if(val.electricityBillForLandlord){
                        this.inLandlordReport.electricityBillForLandlord = true
                    }
                    if(val.gasBillForLandlord){
                        this.inLandlordReport.gasBillForLandlord = true
                    }
                    if(val.repairBillForLandlord){
                        this.inLandlordReport.repairBillForLandlord = true
                    }
                    if(val.parkingBillForLandlord){
                        this.inLandlordReport.parkingBillForLandlord = true
                    }
                    if(val.managementBillForLandlord){
                        this.inLandlordReport.managementBillForLandlord = true
                    }
                    if(val.internetBillForLandlord){
                        this.inLandlordReport.internetBillForLandlord = true
                    }
                    if(val.tvBillForLandlord){
                        this.inLandlordReport.tvBillForLandlord = true
                    }
                    if(val.cleaningBillForLandlord){
                        this.inLandlordReport.cleaningBillForLandlord = true
                    }
                    if(val.otherBillForLandlord){
                        this.inLandlordReport.otherBillForLandlord = true
                    }
                }
                if(val.rentForLandlord > val.rent){
                    this.error.rentForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.rentForLandlord = null
                }
                if(val.bookingDepositForLandlord > val.bookingDeposit){
                    this.error.bookingDepositForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.bookingDepositForLandlord = null
                }
                if(val.contractDepositForLandlord > val.contractDeposit){
                    this.error.contractDepositForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.contractDepositForLandlord = null
                }
                if(val.waterBillForLandlord > val.waterBill){
                    this.error.waterBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.waterBillForLandlord = null
                }
                if(val.electricityBillForLandlord > val.electricityBill){
                    this.error.electricityBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.electricityBillForLandlord = null
                }
                if(val.gasBillForLandlord > val.gasBill){
                    this.error.gasBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.gasBillForLandlord = null
                }
                if(val.parkingBillForLandlord > val.parkingBill){
                    this.error.parkingBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.parkingBillForLandlord = null
                }
                if(val.managementBillForLandlord > val.managementBill){
                    this.error.managementBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.managementBillForLandlord = null
                }
                if(val.internetBillForLandlord > val.internetBill){
                    this.error.internetBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.internetBillForLandlord = null
                }
                if(val.tvBillForLandlord > val.tvBill){
                    this.error.tvBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.tvBillForLandlord = null
                }
                if(val.repairBillForLandlord > val.repairBill){
                    this.error.repairBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.repairBillForLandlord = null
                }
                if(val.cleaningBillForLandlord > val.cleaningBill){
                    this.error.cleaningBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.cleaningBillForLandlord = null
                }
                if(val.otherBillForLandlord > val.otherBill){
                    this.error.otherBillForLandlord = '不可大於跟房客收的金額'
                }else{
                    this.error.otherBillForLandlord = null
                }

                if(val.rent){
                    this.error.rent = null
                }
                if(val.bookingDeposit){
                    this.error.bookingDeposit = null
                }
                if(val.contractDeposit){
                    this.error.contractDeposit = null
                }
                if(val.repairBill){
                    this.error.repairBill = null
                }
                if(val.waterBill){
                    this.error.waterBill = null
                }
                if(val.electricityBill){
                    this.error.electricityBill = null
                }
                if(val.parkingBill){
                    this.error.parkingBill = null
                }
                if(val.managementBill){
                    this.error.managementBill = null
                }
                if(val.managementBill){
                    this.error.managementBill = null
                }
                if(val.tvBill){
                    this.error.tvBill = null
                }
                if(val.repairBill){
                    this.error.repairBill = null
                }
                if(val.cleaningBill){
                    this.error.cleaningBill = null
                }
                if(val.gasBill){
                    this.error.gasBill = null
                }
                if(val.otherBill){
                    this.error.otherBill = null
                }
            },
            deep: true,
        },
        inLandlordReport: {
            handler: function (val) {
                console.log(val)
                if(!val.rentForLandlord){
                    this.error.rent = null
                    this.error.rentForLandlord = null
                    this.insertData.rentForLandlord = null
                }
                if(!val.bookingDepositForLandlord){
                    this.error.bookingDeposit = null
                    this.error.bookingDepositForLandlord = null
                    this.insertData.bookingDepositForLandlord = null
                }
                if(!val.contractDepositForLandlord){
                    this.error.contractDeposit = null
                    this.error.contractDepositForLandlord = null
                    this.insertData.contractDepositForLandlord = null
                }
                if(!val.waterBillForLandlord){
                    this.error.waterBill = null
                    this.error.waterBillForLandlord = null
                    this.insertData.waterBillForLandlord = null
                }
                if(!val.electricityBillForLandlord){
                    this.error.electricityBill = null
                    this.error.electricityBillForLandlord = null
                    this.insertData.electricityBillForLandlord = null
                }
                if(!val.gasBillForLandlord){
                    this.error.gasBill = null
                    this.error.gasBillForLandlord = null
                    this.insertData.gasBillForLandlord = null
                }
                if(!val.parkingBillForLandlord){
                    this.error.parkingBill = null
                    this.error.parkingBillForLandlord = null
                    this.insertData.parkingBillForLandlord = null
                }
                if(!val.managementBillForLandlord){
                    this.error.managementBill = null
                    this.error.managementBillForLandlord = null
                    this.insertData.managementBillForLandlord = null
                }
                if(!val.internetBillForLandlord){
                    this.error.internetBill = null
                    this.error.internetBillForLandlord = null
                    this.insertData.internetBillForLandlord = null
                }
                if(!val.tvBillForLandlord){
                    this.error.tvBill = null
                    this.error.tvBillForLandlord = null
                    this.insertData.tvBillForLandlord = null
                }
                if(!val.cleaningBillForLandlord){
                    this.error.cleaningBill = null
                    this.error.cleaningBillForLandlord = null
                    this.insertData.cleaningBillForLandlord = null
                }
                if(!val.otherBillForLandlord){
                    this.error.otherBill = null
                    this.error.otherBillForLandlord = null
                    this.insertData.otherBillForLandlord = null
                }
                if(!val.repairBillForLandlord){
                    this.error.repairBill = null
                    this.error.repairBillForLandlord = null
                    this.insertData.repairBillForLandlord = null
                }
            },
            deep: true
        },
        'insertData.billType': function (val) {
            this.error.billName = null
            this.error.billPeriodSeq = null
            this.error.billDueTime = null
        },
        periodDate: {
            handler: function (val){
                this.insertData.periodStartDate = val[0]?val[0]:null
                this.insertData.periodEndDate = val[1]?val[1]:null
            },
            deep: true
        },
        periodsList: function (val) {
            if(val.length == 0){
                this.error.billPeriodSeq = '無可用帳單'
            }else{
                this.error.billPeriodSeq = ''
            }
        },
    },
    methods: {
        setMeterCid: function (value, type) {
            if(type === 'ELECTRICITY'){
                this.insertData.utilityIdList[0] = value
            }else if(type === 'WATER'){
                this.insertData.utilityIdList[1] = value
            }else if(type === 'GAS'){
                this.insertData.utilityIdList[2] = value
            }
        },
        importMeter: function (type) {
            if(this.isEdit) return
            if(type === 'WATER'){
                this.modalState.water = true  
            }else if(type === 'ELECTRICITY'){
                this.modalState.electricity = true  
            }else if(type === 'GAS'){
                this.modalState.gas = true  
            }
        },
        setPriceForLandlord: function (type) {
            if(this.status.isLandlord){
                if(type === 'rent'){
                    if(this.insertData.rent && this.inLandlordReport.rentForLandlord){
                        this.insertData.rentForLandlord = Math.round(this.insertData.rent - (this.insertData.rent*this.serviceFeeRate))
                    }else{
                        this.insertData.rentForLandlord = null
                    }
                }else if(type === 'bookingDeposit'){
                    if(this.insertData.bookingDeposit && this.inLandlordReport.bookingDepositForLandlord){
                        this.insertData.bookingDepositForLandlord = Math.round(this.insertData.bookingDeposit - (this.insertData.bookingDeposit*this.serviceFeeRate))
                    }else{
                        this.insertData.bookingDepositForLandlord = null
                    }
                }
            }
        },
        getSelectId: function (value) {
            // console.log(value)
            if( value.ref == 'billType' ){
                this.insertData.billType = value.id
            }else if ( value.ref == 'period' ){
                this.insertData.billPeriodSeq = value.id
            }
        },
        getServiceFeeRate: function (cid) {
            console.log(cid)
            let params = {
                contractSeq: cid
            }
            getServiceFeeRate(params)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.serviceFeeRate = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
            
        },
        getBillPeriods: function (cid) {
            if(cid){
                let params = {
                    contractCid: cid
                }
                getBillPeriods(params)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.periodsList = res.data.result
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
            
        },
        checkInput: function () {
            if(!this.insertData.billType){
                this.error.billType = '請選擇收費方式'
            }else{
                this.error.billType = ''
            }
            if(this.insertData.billType === 'DAY' && !this.insertData.billDueTime){
                this.error.billDueTime = '請選擇收費日'
            }else{
                this.error.billDueTime = ''
            }
            if(!this.insertData.billName){
                this.error.billName = '請填寫帳單名稱'
            }else{
                this.error.billName = ''
            }
            if(this.insertData.billType === 'PERIOD' && !this.insertData.billPeriodSeq){
                this.error.billPeriodSeq = '請選擇收費區間'
            }else{
                this.error.billPeriodSeq = ''
            }
            if(this.inLandlordReport.rentForLandlord){
                if(!this.insertData.rent){
                    this.error.rent = '請輸入金額'
                }
                if(!this.insertData.rentForLandlord){
                    this.error.rentForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.bookingDepositForLandlord){
                if(!this.insertData.bookingDeposit){
                    this.error.bookingDeposit = '請輸入金額'
                }
                if(!this.insertData.bookingDepositForLandlord){
                    this.error.bookingDepositForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.contractDepositForLandlord){
                if(!this.insertData.contractDeposit){
                    this.error.contractDeposit = '請輸入金額'
                }
                if(!this.insertData.contractDepositForLandlord){
                    this.error.contractDepositForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.waterBillForLandlord){
                if(!this.insertData.waterBill){
                    this.error.waterBill = '請輸入金額'
                }
                if(!this.insertData.waterBillForLandlord){
                    this.error.waterBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.electricityBillForLandlord){
                if(!this.insertData.electricityBill){
                    this.error.electricityBill = '請輸入金額'
                }
                if(!this.insertData.electricityBillForLandlord){
                    this.error.electricityBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.gasBillForLandlord){
                if(!this.insertData.gasBill){
                    this.error.gasBill = '請輸入金額'
                }
                if(!this.insertData.gasBillForLandlord){
                    this.error.gasBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.parkingBillForLandlord){
                if(!this.insertData.parkingBill){
                    this.error.parkingBill = '請輸入金額'
                }
                if(!this.insertData.parkingBillForLandlord){
                    this.error.parkingBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.managementBillForLandlord){
                if(!this.insertData.managementBill){
                    this.error.managementBill = '請輸入金額'
                }
                if(!this.insertData.managementBillForLandlord){
                    this.error.managementBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.internetBillForLandlord){
                if(!this.insertData.internetBill){
                    this.error.internetBill = '請輸入金額'
                }
                if(!this.insertData.internetBillForLandlord){
                    this.error.internetBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.tvBillForLandlord){
                if(!this.insertData.tvBill){
                    this.error.tvBill = '請輸入金額'
                }
                if(!this.insertData.tvBillForLandlord){
                    this.error.tvBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.repairBillForLandlord){
                if(!this.insertData.repairBill){
                    this.error.repairBill = '請輸入金額'
                }
                if(!this.insertData.repairBillForLandlord){
                    this.error.repairBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.cleaningBillForLandlord){
                if(!this.insertData.cleaningBill){
                    this.error.cleaningBill = '請輸入金額'
                }
                if(!this.insertData.cleaningBillForLandlord){
                    this.error.cleaningBillForLandlord = '請輸入金額'
                }
            }
            if(this.inLandlordReport.otherBillForLandlord){
                if(!this.insertData.otherBill){
                    this.error.otherBill = '請輸入金額'
                }
                if(!this.insertData.otherBillForLandlord){
                    this.error.otherBillForLandlord = '請輸入金額'
                }
            }
            // if(!this.insertData.rent){
            //     this.error.rent = '請填寫金額'
            // }else{
            //     this.error.rent = ''
            // }

            
            if( !this.insertData.rent &&
                !this.insertData.bookingDeposit &&
                !this.insertData.contractDeposit &&
                !this.insertData.repairBill &&
                !this.insertData.waterBill &&
                !this.insertData.electricityBill &&
                !this.insertData.parkingBill &&
                !this.insertData.managementBill &&
                !this.insertData.tvBill &&
                !this.insertData.cleaningBill &&
                !this.insertData.gasBill &&
                !this.insertData.otherBill &&
                !this.insertData.internetBill){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '至少輸入一筆金額',type: 'error',closeBtn: true})
                    return false
            }
            if(
                !this.error.contractCid &&
                !this.error.billName &&
                !this.error.billPeriodSeq &&
                !this.error.billDueTime &&
                !this.error.periodStartDate &&
                !this.error.periodEndDate &&
                !this.error.rent &&
                !this.error.bookingDeposit &&
                !this.error.contractDeposit &&
                !this.error.repairBill &&
                !this.error.waterBill &&
                !this.error.electricityBill &&
                !this.error.parkingBill &&
                !this.error.managementBill &&
                !this.error.internetBill &&
                !this.error.tvBill &&
                !this.error.gasBill &&
                !this.error.otherBill &&
                !this.error.rentForLandlord &&
                !this.error.bookingDepositForLandlord &&
                !this.error.contractDepositForLandlord &&
                !this.error.repairBillForLandlord &&
                !this.error.waterBillForLandlord &&
                !this.error.electricityBillForLandlord &&
                !this.error.gasBillForLandlord &&
                !this.error.parkingBillForLandlord &&
                !this.error.managementBillForLandlord &&
                !this.error.internetBillForLandlord &&
                !this.error.tvBillForLandlord &&
                !this.error.cleaningBillForLandlord &&
                !this.error.otherBillForLandlord 
            ){
                return true
            }
        },
        saveData() {
            if(!this.checkInput()) return
            const data = this.insertData
            this.status.isDisable = true
            createBill(data)
            .then(res => {
                this.status.isDisable = false
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '已通知房客繳交租金',description: '<a href="/enterprise/financialReport/billMgt">帳單紀錄 <img src="../../../static/img/black-arrow-down.svg" /></a>',type: 'success',closeBtn: true})
                    this.$router.push({name: 'bizLeaseMgtDefault'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error',closeBtn: true})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error',closeBtn: true})
            })
        },
        updateData() {
            if(!this.checkInput()) return
            const data = this.insertData
            this.status.isDisable = true
            updateBill(data)
            .then(res => {
                this.status.isDisable = false
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '編輯帳單成功',type: 'success',closeBtn: true})
                    this.$router.push({name: 'billMgt'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error',closeBtn: true})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error',closeBtn: true})
            })
        },
        getEditBill() {
            const params = {
                billSeq: this.$route.query.seq
            }
            getEditBill(params)
            .then(res => {
                console.log('getEditBill',res)
                if( res.data.status == "SUCCESS" ){
                    this.insertData = res.data.result
                    this.getHouseLandlord(this.insertData.contractCid)
                    if(this.insertData.billType === 'PERIOD'){
                        this.seletcMsg.period = this.insertData.periodStartDate+'~'+this.insertData.periodEndDate
                    }else if(this.insertData.billType === 'DAY'){
                        this.periodDate[0] = this.insertData.periodStartDate
                        this.periodDate[1] = this.insertData.periodEndDate
                    }
                    this.getBillPeriods(this.insertData.contractCid)
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error',closeBtn: true})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error',closeBtn: true})
            })
        },
        getHouseLandlord(contractCid) {
            const params = {
                contractCid: contractCid
            }
            getHouseLandlord(params)
            .then(res => {
                console.log('getHouseLandlord',res)
                if( res.data.status == "SUCCESS" ){
                    if(res.data.result){
                        this.status.isLandlord = true
                    }else{
                        this.status.isLandlord = false
                        this.inLandlordReport.rentForLandlord = false
                        this.inLandlordReport.bookingDepositForLandlord = false
                    }
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error',closeBtn: true})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error',closeBtn: true})
            })
        },
        notBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date < today;
        },
    },
    computed: {
        ...mapGetters({
            employeeRoleList: 'GET_BIZ_EMPLOYEE_ROLE_LIST',
            organizationGroupList: 'GET_BIZ_ORGANIZATION_GROUP_LIST',
        })
    },
    components: {
        toogleBlock,
        RentSelect,
        btnLoading,
        titleTips,
        borderRadio,
        Checkbox,
        DatePicker,
        billReciveTipsHover,
        importMeterRecord
    }
}
</script>
<style lang="scss">
    .biz-new-bill-comp{
        padding-bottom: 300px;
        .page-header{
            .btn-group{
                .loading-wrap{
                    position: relative;
                    width: 100%;
                    .default-button{
                        width: 120px;
                        padding: 14px 0 14px 0;
                    }
                    .btn-loading{
                        left: 5px;
                        top: 6px;
                    }
                }
            }
        }
        .toogle-title{
            position: relative;
        }
        .toggle-block > .toogle-body {
            padding: 0 60px 24px 24px;
            .tips-agent{
                font-size: 20px;
                font-weight: 500;
                .ad-title{
                    margin-bottom: 10px;
                }
                .rent{
                    color: #a19d9c;
                    margin-bottom: 16px;
                    .unit{
                        font-size: 14px;
                    }
                }
                .agent{
                    display: flex;
                    align-items: center;
                    .name{
                        color: #fc7171;
                        margin-left: 8px;
                        margin-right: 12px;
                    }
                    .phone{
                        margin-right: 10px;
                        color: #3a455f;
                    }
                }
            }
            .biz-table .biz-table-row .biz-table-title {
                width: 85px;
            }
        }
        .row-block {
            display: flex;
            align-items: flex-start;
            // justify-content: space-between;
            .meter-group{
                justify-content: space-between;
                >input{
                    width: 194px;
                }
                .border-button-gray{
                    width: 118px;
                    height: 42px;
                    line-height: 1.5;
                }
            }
            .meter-warning{
                color: #ff9275;
                margin-top: 8px;
                >img{
                    margin-right: 4px;
                }
            }
            >div{
                margin-right: 60px;
                &:last-child{
                    margin-right: 0px;
                }
            }
            .border-radio{
                width: 156px;
                margin-right: 12px;
            }
            .mx-datepicker{
                width: 324px;
            }
        }
        .col2-input {
            position: relative;
            width: 324px;
            margin-bottom: 24px;
            .checkbox{
                margin-top: 9px;
            }
            .is-created{
                color: #a19d9c;
                width: 111%;
                height: 100%;
                margin-left: -16px;
                margin-right: -16px;
                display: flex;
                align-items: center;
                padding-left: 16px;
            }

            select {
                width: 100%;
                height: 42px;
                padding: 0 12px;
                border: 1px solid #d5dad8;
                border-radius: 4px;
                background-color: #fff;
                font-size: 14px;
                color: #3a455f;
                outline: none;
                cursor: pointer;
                
                &.error {
                    border-color: #ff9275;
                }
                
                &:disabled {
                    background-color: #f5f5f5;
                    cursor: not-allowed;
                    color: #a19d9c;
                }
                
                // 移除預設的下拉箭頭樣式(可選)
                appearance: none;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%233a455f' d='M1.41 0L6 4.59L10.59 0L12 1.41l-6 6l-6-6z'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: right 12px center;
                padding-right: 32px;
            }

        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/billMgt/newBillComp.vue